import './index.less'
import { observer } from 'mobx-react'
import { Image, Space, Tabs, Typography } from 'antd'
import { useEffect, useState } from 'react'
import type { TabsProps } from 'antd'
import useStore from '@/hooks/useStore'
import FacilityInfoTabs from '@/components/Content/FacilityInfo/FacilityInfoTabs'
import FacilityRecordTabs from '@/components/Content/FacilityInfo/FacilityRecordTabs'
import FacilitySupportTabs from '@/components/Content/FacilityInfo/FacilitySupportTabs'
import FacilityInquiryTabs from '@/components/Content/FacilityInfo/FacilityInquiryTabs'

const { Title, Text } = Typography

function FacilityInfo() {
  const facilityStore = useStore('facilityStore')
  const uiStore = useStore('uiStore')
  const [imgSrc, setImgSrc] = useState('')
  const [name, setName] = useState('')
  const [info1, setInfo1] = useState('')
  const [info2, setInfo2] = useState('')
  const tabsArr: TabsProps['items'] = [
    {
      key: '1',
      label: '시설정보',
      children: <FacilityInfoTabs flrNo={facilityStore.FacilityInfoObj.flrNo} hoCnt={facilityStore.FacilityInfoObj.hoCnt} />,
    },
    {
      key: '2',
      label: '거래이력',
      children: <FacilityRecordTabs />,
    },
    {
      key: '3',
      label: '지원정책',
      children: <FacilitySupportTabs />,
    },
    {
      key: '4',
      label: '문의하기',
      children: <FacilityInquiryTabs />,
    },
  ]
  useEffect(() => {
    if (facilityStore.FacilityInfoObj !== null) {
      setImgSrc(facilityStore.FacilityInfoObj.imgSrc)
      setName(facilityStore.FacilityInfoObj.name)
      setInfo1(facilityStore.FacilityInfoObj.info1)
      setInfo2(facilityStore.FacilityInfoObj.info2)
    }
  }, [facilityStore.FacilityInfoObj])
  const facilityInfoHide = () => {
    facilityStore.facilityInfoHide()
  }

  return (
    <div className={'FacilityInfo'}>
      <div className={'imgDiv'}>
        <Image height={346} width={600} src={imgSrc} preview={false} />
      </div>
      <div className={'detail-info-inner'} style={{ height: uiStore.uiHeight - 346 }}>
        <div className={'head-inner'}>
          <Title level={4}>{name}</Title>
          <Space size={[24, 4]} wrap>
            <div>
              면적&nbsp;&nbsp;<Text style={{ fontWeight: 'bold' }}>{info1}</Text>
            </div>
            <div>
              규모&nbsp;&nbsp;<Text style={{ fontWeight: 'bold' }}>{info2}</Text>
            </div>
          </Space>
        </div>
        <div className={'body-inner'}>
          <Tabs defaultActiveKey="1" items={tabsArr} />
        </div>
      </div>
      <div className={'FacilityInfo-HideButton'}>
        <button onClick={facilityInfoHide} className={'btn-fold'} />
      </div>
    </div>
  )
}

export default observer(FacilityInfo)
